import {roles} from "../utils/roles";


const getHomePageUrl = (role) => {
    let url = '';
    switch(role){
        case roles.hbAdministrator:
           url = '/sps-account-home' ;
           break;
        case roles.hbViewer:
            url = '/sps-monthlyprice' ;
            break;
        case roles.rmOperator:
            url = '/sw-download' ;
            break;
        case roles.rmSupervisor:
            url = '/account' ;
            break;
        case roles.rmAdministrator:
            url = '/account' ;
            break;
        case roles.spsAdministrator:
            url = '/sps-account-home' ;
            break;

        case roles.rmOperator:
        case roles.rmSupervisor:
        case roles.rmAdministrator:
            url = '/supply-encoding-home';
            break;
        case roles.suppliesBusinessOwner:
            url = '/sps-supply-catalog';
            break;
        case roles.viewer:
        case roles.pricingAdmin:
        case roles.salesRep:
            url= '/sps-monthlyprice';
            break;
        default:
            url='/';
    }
    return url;
}

export default getHomePageUrl;